import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Pagenation',
  props: {
    total: {},
    pageSize: {},
    pageNum: {}
  },
  emits: ["changePage"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
// 更改dialog的显示与隐藏
let emit = __emit;

// 改变页码
const currentChange = (currentPage: number) => {
  emit("changePage", currentPage);
};

const prevPage = (currentPage: number) => {
  emit("changePage", currentPage);
};

const nextPage = (currentPage: number) => {
  emit("changePage", currentPage);
};

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createBlock(_component_el_pagination, {
    small: "",
    background: "",
    layout: "prev, pager, next",
    total: props.total,
    "page-size": props.pageSize,
    "default-current-page": props.pageNum,
    onCurrentChange: currentChange,
    onPrevClick: prevPage,
    onNextClick: nextPage
  }, null, 8, ["total", "page-size", "default-current-page"]))
}
}

})